var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-most-appreciated"},[_vm._l((_vm.users),function(user,i){return _c('MostAppreciatedItem',{key:i,attrs:{"is-first":i===0,"position":i+1,"user":user.externalUser,"points":user.listPoints}})}),(!_vm.users.length)?_c('i',[_vm._v(" "+_vm._s(_vm.$t('mostAppreciated.no-entries'))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }